import InlineToast from '@/components/ui/toast/InlineToast';
import { useState } from 'react';
import { FaFacebookF, FaWhatsapp } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { FiLink } from 'react-icons/fi';

/**
 * Helper: hapus semua HTML tag
 */
const stripHtml = (html = '') =>
  html
    .replace(/<[^>]*>?/gm, '')
    .replace(/\s+/g, ' ')
    .trim();

export default function ShareButtons({ title, slug, content }) {
  const frontendUrl = window.location.origin;
  const newsUrl = `${frontendUrl}/berita/${slug}`;

  // 🔹 Bersihkan HTML
  const plainText = stripHtml(content);

  // 🔹 Ambil 2 kalimat pertama
  const sentences = plainText.split(/(?<=[.!?])\s+/);
  const preview = sentences.slice(0, 2).join(' ');

  // 🔹 Batasi panjang (SEO friendly)
  const description = preview.length > 160 ? preview.slice(0, 160) + '…' : preview;

  // 🔹 WhatsApp text
  const whatsappText = encodeURIComponent(
    `${title}\n\n${description}\n\nBaca selengkapnya:\n${newsUrl}`
  );

  const [toast, setToast] = useState({ show: false, message: '' });
  const [copyLoading, setCopyLoading] = useState(false);

  const handleCopy = async () => {
    try {
      setCopyLoading(true);
      await navigator.clipboard.writeText(newsUrl);
      setToast({ show: true, message: 'Link berhasil disalin!' });
      setTimeout(() => setToast({ show: false, message: '' }), 1500);
    } finally {
      setCopyLoading(false);
    }
  };

  const buttonClasses = 'p-2 rounded-lg transition flex items-center justify-center';

  return (
    <div className="mt-6 flex items-center justify-between pt-4 border-t">
      {/* Label */}
      <div className="flex-grow flex items-center">
        <h6 className="text-xs lg:text-sm font-medium w-full text-right">Bagikan :</h6>
      </div>

      {/* Buttons */}
      <div className="flex items-center gap-3 ml-4">
        {/* WhatsApp */}
        <a
          href={`https://wa.me/?text=${whatsappText}`}
          target="_blank"
          rel="noopener noreferrer"
          className={`${buttonClasses} bg-green-50 hover:bg-green-100 text-green-600`}
        >
          <FaWhatsapp className="text-[20px] lg:text-[22px]" />
        </a>

        {/* Facebook */}
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(newsUrl)}`}
          target="_blank"
          rel="noopener noreferrer"
          className={`${buttonClasses} bg-blue-50 hover:bg-blue-100 text-blue-600`}
        >
          <FaFacebookF className="text-[20px] lg:text-[22px]" />
        </a>

        {/* Twitter / X */}
        <a
          href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
            newsUrl
          )}&text=${encodeURIComponent(title)}`}
          target="_blank"
          rel="noopener noreferrer"
          className={`${buttonClasses} bg-black/10 hover:bg-black/20 text-black`}
        >
          <FaXTwitter className="text-[20px] lg:text-[22px]" />
        </a>

        {/* Copy Link */}
        <div className="relative">
          <InlineToast show={toast.show} message={toast.message} />
          <button
            onClick={handleCopy}
            className={`${buttonClasses} bg-gray-100 hover:bg-gray-200 text-gray-600`}
          >
            {copyLoading ? (
              <div className="w-5 h-5 border-2 border-gray-400 border-t-transparent rounded-full animate-spin"></div>
            ) : (
              <FiLink className="text-[20px] lg:text-[22px]" />
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
